import { createContext, useState } from "react";

// export type GlobalVideosType = React.PropsWithChildren<{
//   value: {
//     videos: {}[];
//     setVideos: Function;
//   };
// }>;

interface GlobalVideosList {
  children: React.ReactNode;
}

const initiateValue = {
  videos: [
    {
      videoURL: "",
      _id: "",
      sensitivity: "",
      date: "",
      duration: 0,
      provider: "",
      postcode: "",
      locality: "",
      thumbnail: [""],
      name: "",
      camera: "",
      keywords: [""],
      location: {},
      orientation: "",
      __v: 0,
    },
  ],
  setVideos: (
    videos: {
      videoURL: string;
      _id: string;
      sensitivity: string;
      date: string;
      duration: number;
      provider: string;
      postcode: string;
      locality: string;
      thumbnail: string[];
      name: string;
      camera: string;
      keywords: string[];
      location: {};
      orientation: string;
      __v: number;
    }[]
  ) => {},
};

export const VideosContext = createContext(initiateValue);

export function VideoProvider({ children }: GlobalVideosList) {
  const [videos, setVideos] = useState<
    {
      videoURL: string;
      _id: string;
      sensitivity: string;
      date: string;
      duration: number;
      provider: string;
      postcode: string;
      locality: string;
      thumbnail: string[];
      name: string;
      camera: string;
      keywords: string[];
      location: {};
      orientation: string;
      __v: number;
    }[]
  >([]);
  return (
    <VideosContext.Provider value={{ videos, setVideos }}>
      {children}
    </VideosContext.Provider>
  );
}
